module.exports = "<div class=\"modal-header\">\n\t<div class=\"title\">Odaberite tip fajla</div>\n\t<div class=\"close\"><i class=\"material-icons\" ng-click=\"exit()\">close</i></div>\n</div>\n<div class=\"modal-content\">\n\t<div ng-if=\"!loading\">\n\t\t<div class=\"btn btn-blue btn-right\" ng-click=\"export('pdf')\">PDF</div>\n\n\t\t<div class=\"btn btn-blue btn-right\" ng-click=\"export('xls')\">Excel</div>\n\t</div>\n\t<div ng-if=\"loading\">\n\t\tExportovanje u toku\n\t</div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./scripts/apps/shop/views/modal-export-products.html
// module id = 358
// module chunks = 0